import { render, staticRenderFns } from "./CourseIcon.vue?vue&type=template&id=b0f64c86"
import script from "./CourseIcon.vue?vue&type=script&lang=js"
export * from "./CourseIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports